"use client";

import { datadogRum } from "@datadog/browser-rum";
import {
  APP_VERSION,
  DATADOG_APPLICATION_ID,
  DATADOG_CLIENT_TOKEN,
  DATADOG_ENV,
  DATADOG_SERVICE,
  DATADOG_SESSION_SAMPLE_RATE,
  DATADOG_SITE
} from "config";

datadogRum.init({
  applicationId: DATADOG_APPLICATION_ID || "",
  clientToken: DATADOG_CLIENT_TOKEN || "",
  site: DATADOG_SITE,
  env: DATADOG_ENV,
  service: DATADOG_SERVICE,
  version: APP_VERSION,
  sessionPersistence: "local-storage",
  sessionSampleRate: DATADOG_SESSION_SAMPLE_RATE,
  trackUserInteractions: true,
  trackLongTasks: true,
  trackResources: true,
  trackSessionAcrossSubdomains: true
});

export default function DatadogRUMInit() {
  // Render nothing - this component is only included so that the init code
  // above will run client-side
  return null;
}
